function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 44.363281 26.90625 L 255.863281 26.90625 L 255.863281 272.71875 L 44.363281 272.71875 Z M 44.363281 26.90625 "
})));

function SvgWatchlistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    viewBox: "0 0 300 299.999988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.508972%,58.039856%,60.389709%)",
      fillOpacity: 1
    },
    d: "M 229.539062 224.261719 L 229.539062 54.582031 C 229.128906 54.113281 227.839844 53.242188 225.761719 53.242188 L 74.699219 53.242188 C 72.621094 53.242188 71.332031 54.113281 70.921875 54.582031 L 70.921875 224.261719 L 135.851562 182.335938 C 140.226562 179.511719 145.226562 178.101562 150.230469 178.101562 C 155.234375 178.101562 160.234375 179.511719 164.609375 182.335938 L 229.539062 224.261719 M 255.972656 272.71875 L 150.230469 204.4375 L 44.488281 272.71875 L 44.488281 54.21875 C 44.488281 39.132812 58.015625 26.90625 74.699219 26.90625 L 225.761719 26.90625 C 242.445312 26.90625 255.972656 39.132812 255.972656 54.21875 Z M 255.972656 272.71875 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.508972%,58.039856%,60.389709%)",
      fillOpacity: 1
    },
    d: "M 67.507812 52.332031 L 232.574219 52.332031 L 232.574219 89.316406 L 67.507812 89.316406 Z M 67.507812 52.332031 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlistIcon);
export default __webpack_public_path__ + "static/media/WatchlistIcon.9ed19ef1.svg";
export { ForwardRef as ReactComponent };